module.exports = __webpack_public_path__ + "img/mp1.e1ac4ef8.png";